/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../../common';
import { translate } from '../../../common/translation/translate';
import { MediaNav } from '../../common/subnavigation/mediaNav';
import { PageSubNavLink } from '../../common/subnavigation/pageSubNavLink';
import { WeatherTrafficPageId, WeatherTrafficRoutePaths } from './weatherTrafficNavigationTypes';
import type { IStoreState } from '../../common/interfaces/types';

interface WeatherTrafficNavigationProps {
    activePageId: string;
    SlugName: string;
    enableTrafficCamerasPageOnWeb2: boolean;
    enableWeatherCamerasPageOnWeb2: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { pageId, user, enableTrafficCamerasPageOnWeb2, enableWeatherCamerasPageOnWeb2 } = storeState?.appState?.appState || {};
    const { ActiveLocation } = user || {};
    const { SlugName } = ActiveLocation?.Locality || {};
    return {
        activePageId: pageId,
        SlugName,
        enableTrafficCamerasPageOnWeb2,
        enableWeatherCamerasPageOnWeb2
    };
};

const mapDispatchToProps = {};

export const WeatherTrafficNavigation = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo((
    {
        activePageId,
        SlugName,
        enableTrafficCamerasPageOnWeb2,
        enableWeatherCamerasPageOnWeb2
    }: WeatherTrafficNavigationProps) => {
    return (
        <MediaNav>
            <Container>
                <PageSubNavLink
                    isActive={activePageId === WeatherTrafficPageId.weatherPageId}
                    linkName={translate('weatherCams')}
                    linkUrl={`${WeatherTrafficRoutePaths.weatherRoutePath}${SlugName}`}
                    linkToWeb2={enableWeatherCamerasPageOnWeb2}
                />
                <PageSubNavLink
                    isActive={activePageId === WeatherTrafficPageId.trafficPageId}
                    linkName={translate('trafficCams')}
                    linkUrl={`${WeatherTrafficRoutePaths.trafficRoutePath}${SlugName}`}
                    linkToWeb2={enableTrafficCamerasPageOnWeb2}
                />
            </Container>
        </MediaNav>
    );
}));

WeatherTrafficNavigation.displayName = 'WeatherTrafficNavigation';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;